import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import styles from './SoftwarePage.module.scss';

//Components
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import HeroButtonModal from '../../components/HeroButtonModal/HeroButtonModal';
import StreamField from '../../components/StreamField/StreamField';
import Breadcrumbs from '../../components/Breadcrumbs';

const SoftwarePage = ({ settings, hero, content, breadcrumbs, title }) => {

    const handleLinkClick = (event) => {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'software_download',
                software_name: title,
                file_name: event.target.innerText
            });
        }
    };

    const handleModalButtonClick = (event, buttonText) => {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'software_download',
                software_name: title,
                file_name: buttonText
            });
        }
    }
    
    return (
        <div className={styles['SoftwarePage']}>
            <Header {...settings.header} />
            <div className={styles['SoftwarePage__Container']}>
                <div className={styles['SoftwarePage__Breadcrumbs']}>
                    <Breadcrumbs {...breadcrumbs} />
                </div>
                <main>
                    {hero && <HeroButtonModal {...hero} onLinkClick={handleLinkClick} onClick={handleModalButtonClick}/>}
                    <div className={styles['SoftwarePage__Wrapper']}>
                        <div className={styles['SoftwarePage__Divider']}></div>
                    </div>
                    {content && <StreamField items={content} />}
                </main>
            </div>
            <Footer {...settings.footer} />
        </div>
    );
};

SoftwarePage.propTypes = {
    hero: PropTypes.object,
    footer: PropTypes.object,
    content: PropTypes.array,
};

SoftwarePage.defaultProps = {
    settings: {
        hero: {},
        footer: {},
    },
    hero: {},
    content: [],
};

export default basePageWrap(SoftwarePage);
